import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaCloudUploadAlt, FaCamera, FaSearch, FaTimes,
  FaPaw, FaMapMarkerAlt
} from "react-icons/fa";
import { ORASE, RASE_CAINE, RASE_PISICA, CULORI } from "../data/optiuniAnunt";
import "./FiltruAcasa.css";

export default function FiltruAcasa() {
  const navigate = useNavigate();
  const [imagine, setImagine] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filtre, setFiltre] = useState({
    tip: "",
    specie: "",
    rasa: "",
    sex: "",
    culoare: "",
    oras: "",
  });
  const fileRef = useRef();
  const cameraRef = useRef();

  const handleFile = (file) => {
    if (!file) return;
    setImagine(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleFiltru = (e) => {
    const { name, value } = e.target;
    setFiltre((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "specie" ? { rasa: "" } : {}),
    }));
  };

  const handleReset = () => {
    setImagine(null);
    setPreview(null);
    setFiltre({ tip: "", specie: "", rasa: "", sex: "", culoare: "", oras: "" });
    if (fileRef.current) fileRef.current.value = "";
  };

const handleCauta = async () => {
  setLoading(true);

  const params = new URLSearchParams();
  Object.entries(filtre).forEach(([k, v]) => {
    if (v && k !== "tip") params.set(k, v);
  });

  if (imagine && process.env.REACT_APP_AI_SERVICE_URL) {
    try {
      // Caută în tipul selectat — sau în "gasit" dacă nu e selectat nimic
      const tipCautare = filtre.tip || "gasit";

      const formData = new FormData();
      formData.append("file", imagine);
      formData.append("tip", tipCautare);

      const res = await fetch(
        `${process.env.REACT_APP_AI_SERVICE_URL}/search`,
        { method: "POST", body: formData }
      );
      const data = await res.json();

      if (data.ids?.length) {
        params.set("ids", data.ids.join(","));
      }
    } catch (err) {
      console.log("AI offline:", err.message);
    }
  }

  setLoading(false);

  // Dacă nu e selectat niciun tip → mergi la animale-gasite ca default
  const destination = filtre.tip === "pierdut"
    ? "/animale-pierdute"
    : "/animale-gasite";

  navigate(`${destination}?${params.toString()}`);
};

  const rase = filtre.specie === "caine" ? RASE_CAINE : RASE_PISICA;

  return (
    <section className="filtru-acasa">

      <div className="fa-imagine-butoane">
        <label className="fa-imagine-card" htmlFor="upload-acasa">
          <input
            id="upload-acasa"
            ref={fileRef}
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleFile(e.target.files[0])}
          />
          <FaCloudUploadAlt className="fa-imagine-icon" />
          <span>Încarcă Poză</span>
        </label>

        <label className="fa-imagine-card" htmlFor="camera-acasa">
          <input
            id="camera-acasa"
            ref={cameraRef}
            type="file"
            accept="image/*"
            capture="environment"
            hidden
            onChange={(e) => handleFile(e.target.files[0])}
          />
          <FaCamera className="fa-imagine-icon" />
          <span>Fă o Poză</span>
        </label>
      </div>

      <div className="fa-divider">
        <span>SAU CAUTĂ DUPĂ DETALII</span>
      </div>

      <div className="fa-avansate">
        <h3><FaSearch /> Căutare Avansată</h3>

        <div className="fa-body">

          {preview && (
            <div className="fa-preview">
              <div className="fa-preview-wrapper">
                <img src={preview} alt="animal" className="fa-preview-img" />
                <button
                  className="fa-btn-remove"
                  onClick={() => { setImagine(null); setPreview(null); }}
                >
                  <FaTimes />
                </button>
              </div>
              <p className="fa-preview-label">
                <FaPaw /> Imagine selectată
              </p>
            </div>
          )}

          <div className="fa-grid">

            <div className="fa-group fa-group-tip">
              <label>Caută în</label>
              <div className="fa-tip-butoane">
                <button
                  className={`fa-tip-btn ${filtre.tip === "gasit" ? "activ-gasit" : ""}`}
                  onClick={() => setFiltre((p) => ({ ...p, tip: "gasit" }))}
                >
                   Animale Găsite
                </button>
                <button
                  className={`fa-tip-btn ${filtre.tip === "pierdut" ? "activ-pierdut" : ""}`}
                  onClick={() => setFiltre((p) => ({ ...p, tip: "pierdut" }))}
                >
                   Animale Pierdute
                </button>
              </div>
            </div>

            <div className="fa-group">
              <label><FaPaw /> Specie</label>
              <select name="specie" value={filtre.specie} onChange={handleFiltru}>
                <option value="">Toate speciile</option>
                <option value="caine"> Câine</option>
                <option value="pisica"> Pisică</option>
              </select>
            </div>

            {filtre.specie && (
              <div className="fa-group">
                <label>Rasă</label>
                <select name="rasa" value={filtre.rasa} onChange={handleFiltru}>
                  <option value="">Toate rasele</option>
                  {rase.map((r) => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="fa-group">
              <label>Sex</label>
              <select name="sex" value={filtre.sex} onChange={handleFiltru}>
                <option value="">Orice sex</option>
                <option value="mascul">♂ Mascul</option>
                <option value="femela">♀ Femelă</option>
              </select>
            </div>

            <div className="fa-group">
              <label>Culoare</label>
              <select name="culoare" value={filtre.culoare} onChange={handleFiltru}>
                <option value="">Orice culoare</option>
                {CULORI.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>

            <div className="fa-group">
              <label><FaMapMarkerAlt /> Oraș</label>
              <select name="oras" value={filtre.oras} onChange={handleFiltru}>
                <option value="">Toate orașele</option>
                {ORASE.map((o) => (
                  <option key={o} value={o}>{o}</option>
                ))}
              </select>
            </div>

          </div>
        </div>

        <div className="fa-actiuni">
          <button
            className="fa-btn-cauta"
            onClick={handleCauta}
            disabled={loading}
          >
            <FaSearch />
            {loading ? "Se caută..." : "Caută Acum"}
          </button>
          <button className="fa-btn-reset" onClick={handleReset}>
            <FaTimes /> Resetează
          </button>
        </div>
      </div>

    </section>
  );
}